/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiCreateNewWaveScope {
    /**
    * If null, everyone is included
    */
    'group_id': string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "group_id",
            "baseName": "group_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCreateNewWaveScope.attributeTypeMap;
    }

    public constructor() {
    }
}
